import webConfig from '../../configs/web.config';

export const pclogout = async () => {
  try {
    const res = await fetch(webConfig?.pclogoutUrl, {
      method: "POST",
    })
    return res;
  } catch {
    return null
  }
};